/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../_metronic/helpers'
import {useDLMLabelSetsQueryRequest} from './DLMLabelSetsQueryRequestProvider'

import { getDLMLabelSets, DLMLabelSet } from '../'


const DLMLabelSetsQueryResponseContext = createResponseContext<DLMLabelSet>(initialQueryResponse)
const DLMLabelSetsQueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useDLMLabelSetsQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const { isFetching, refetch, data: response} = useQuery(
    `DLMLABELSETSLIST`,
    () => { return getDLMLabelSets(); },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <DLMLabelSetsQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
      {children}
    </DLMLabelSetsQueryResponseContext.Provider>
  )
}

const useDLMLabelSetsQueryResponse = () => useContext(DLMLabelSetsQueryResponseContext)

const useDLMLabelSetsQueryResponseData = () => {
  const {response} = useDLMLabelSetsQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useDLMLabelSetsQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useDLMLabelSetsQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useDLMLabelSetsQueryResponseLoading = (): boolean => {
  const {isLoading} = useDLMLabelSetsQueryResponse()
  return isLoading
}

export {
  DLMLabelSetsQueryResponseProvider,
  useDLMLabelSetsQueryResponse,
  useDLMLabelSetsQueryResponseData,
  useDLMLabelSetsQueryResponsePagination,
  useDLMLabelSetsQueryResponseLoading,
}
